import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { Toaster as Sonner } from '@/components/ui/sonner';
import { Toaster } from '@/components/ui/toaster';
import { TooltipProvider } from '@/components/ui/tooltip';

import Index from './pages/Index';
import DigitalServicesComponent from './pages/DigitalServices';
import LessonsComponent from './pages/Lessons';
import LessonsAdminComponent from './pages/LessonsAdminComponent';
import LoginComponent from './pages/Login';
import RegisterComponent from './pages/Register';
import NotFoundComponent from './pages/NotFound';
import ClientsAdminComponent from './pages/ClientsAdminComponent';
import MessagesAdminComponent from './pages/MessagesAdminComponent';
import ContactsComponent from './pages/ContactsComponent';
import InvitationComponent from './pages/InvitationComponent';
import ProfileComponent from './pages/ProfileComponent';

const queryClient = new QueryClient();

// App context
const isSetAppContext = localStorage.getItem('isSetAppContext');
if (!isSetAppContext) {
	localStorage.setItem('isSetAppContext', 'TRUE');
	const appContext = { isLogged: false, user: ' ', email: ' ',role: 'USER' };
	localStorage.setItem('appContext', JSON.stringify(appContext));
}

const App = () => (
	<QueryClientProvider client={queryClient}>
		<TooltipProvider>
			<Toaster />
			<Sonner />
			<BrowserRouter>
				<Routes>
					<Route path="/" element={<Index />} />
					<Route path="/digital-services" element={<DigitalServicesComponent />} />
					{/* العمولة is hidden: src/pages/Commission.tsx is kept, but with no route
					    /commission falls through to "*" and 404s. Restore the route (and the
					    import above) to bring the page back once the rates are final. */}
					<Route path="/lessons" element={<LessonsComponent />} />
					<Route path="/lessons-admin" element={<LessonsAdminComponent />} />
					<Route path="/clients-admin" element={<ClientsAdminComponent />} />
					<Route path="/messages-admin" element={<MessagesAdminComponent />} />
					<Route path="/login" element={<LoginComponent />} />
					<Route path="/register" element={<RegisterComponent />} />
					<Route path="/invitation/:linkId" element={<InvitationComponent />} />
					<Route path="/profile" element={<ProfileComponent />} />
					<Route path="/contact" element={<ContactsComponent />} />
					<Route path="*" element={<NotFoundComponent />} />
				</Routes>
			</BrowserRouter>
		</TooltipProvider>
	</QueryClientProvider>
);

export default App;
